






















































































/* eslint-disable */
import Vue from "vue";
import { MessageMixin } from "@/mixins/MessageMixin";

export default Vue.extend({
	name: "Top",
	mixins: [MessageMixin],
	data: (): {
		inputText: string;
		nickName: string;
		scrollY: number;
		messagesHeight: number;
		app: any;
	} => ({
		inputText: "",
		nickName: "",
		scrollY: 0,
		messagesHeight: 0,
		app: null,
	}),
	computed: {
		isMobile(): boolean {
			if (window.innerWidth < 411) {
				return true;
			} else {
				return false;
			}
		},
		refs(): any {
			return this.$refs;
		},
		judgeMessagesArea() {
			if (this.scrollY > 500 && this.scrollY < this.messagesHeight + 50) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		scrollToArchive(): void {
			const offset = this.isMobile ? 10 : 40;
			this.$vuetify.goTo("#messages", {
				duration: 1000,
				offset: offset,
			});
		},
		scrollToForm(): void {
			const offset = this.isMobile ? -30 : 100;
			this.$vuetify.goTo("#form", {
				duration: 1000,
				offset: offset,
			});
		},
		calculateScrollY(): void {
			this.scrollY = window.scrollY;
			console.log(this.scrollY);
		},
		getMessagesHeight(): void {
			this.messagesHeight = this.refs.messages.clientHeight;
			console.log(this.messagesHeight);
		},
		routeOtuge(inputText: string) {
			const otugeNum: any = Math.floor(Math.random() * (6 - 1) + 1);
			console.log(otugeNum);
			this.$router.push({
				name: "Otuge",
				params: { inputText: inputText, otugeNum: otugeNum },
			});
		},
	},
	mounted(): void {
		window.addEventListener("scroll", this.calculateScrollY);
		setTimeout(() => this.getMessagesHeight(), 1000);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.calculateScrollY);
	},
});
